<template>
    <div>
        <common-table :table-columns="tableColumns" :form-fields="formFields" :permission="permission" :url="url" :operate="[]" :searchs="searchs"/>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "AgentFinance",
        components: {CommonTable},
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                permission:{
                    /*add: 'finance:add',
                    update: 'finance:update',
                    delete: 'finance:delete',
                    deleteBatch: 'finance:deleteBatch'*/
                },
                url: {
                    get: '/finance/listByCondition',
                    /*add: '/finance/add',
                    update: '/finance/update',
                    delete: '/finance/delete/',
                    delete_batch: '/finance/deleteBatch',*/
                },
                tableColumns: [/*{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },*/ {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'rechargeMoney',
                    label: '充值金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeNum',
                    label: '充值人数',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeTimes',
                    label: '充值笔数',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalMoney',
                    label: '提现金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalNum',
                    label: '提现人数',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalTimes',
                    label: '提现笔数',
                    show: true,
                    width: '',
                }, /*{
                    field: 'agencyRatio',
                    label: '代理占成',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'agencyFee',
                    label: '代理费用(USDT)',
                    show: true,
                    width: '',
                },{
                    field: 'profit',
                    label: '盈利(USDT)',
                    show: true,
                    width: '',
                } */],
                formFields: {
                    model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
